import React from 'react';
import moment from 'moment';
import { Icon } from 'antd';
import PropTypes from 'prop-types';
import formatMiles from '../formatMiles';
import s from './styles.less';

export default class Book extends React.Component {
  static propTypes = {
    item: PropTypes.object,
    onClick: PropTypes.func,
    gray: PropTypes.bool,
    ticked: PropTypes.bool,
    inProgress: PropTypes.bool,
    statusType: PropTypes.string,
  };
  render() {
    const { onClick, item, gray, statusType, ticked, inProgress } = this.props;
    return (
      <div
        className={`${s.root} ${onClick ? s.active : ''} ${
          ticked ? s.ticked : ''
        }`}
        onClick={() => onClick && onClick(item)}
      >
        <div className={`${s.status} ${gray ? s.gray : ''}`}>
          {!ticked && <Icon type={statusType} />}
          {ticked && <Icon type="check-circle" />}
        </div>
        <div>
          <div>{item.type}</div>
          {inProgress ? (
            <div>
              <div className={s.expected}>In progress...</div>
              <div className={s.expected}>
                {item.Booking.Provider.companyName}
              </div>
            </div>
          ) : (
            <div>
              {item.expectedDate && (
                <div className={s.expected}>
                  Expected date:{' '}
                  {moment(item.expectedDate).format('DD/MM/YYYY')}
                </div>
              )}
              {item.expectedMileage && (
                <div className={s.expected}>
                  Expected mileage: {formatMiles(item.expectedMileage)}
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    );
  }
}
